export default function Radio(theme) {
  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.Mui-checked': {
            color: theme.palette.primary.main,
          },
        },
      },
    },
    MuiRadioGroup: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexDirection: 'row',
          gap: theme.spacing(1),
        },
      },
    },
  };
}

